import { useState, useEffect, useRef } from 'react';
import trolyaothongminh from '../../../assets/images/trolyaothongminh.jpg';

export default function AIAssistant() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const aiFeatures = [
    {
      icon: 'ri-user-search-line',
      title: 'Gợi ý khách hàng tiềm năng',
      description: 'AI phân tích và đề xuất khách hàng có khả năng chuyển đổi cao nhất dựa trên dữ liệu lịch sử',
      color: 'from-[#06b6d4] to-[#00c897]'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Phân tích hành vi và nhu cầu',
      description: 'Hiểu sâu về hành vi, sở thích và nhu cầu của từng khách hàng để cá nhân hóa trải nghiệm',
      color: 'from-[#2a4b7c] to-[#3d5a80]'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Dự đoán khả năng chuyển đổi',
      description: 'Tính toán tỷ lệ thành công của từng deal và ưu tiên nguồn lực cho cơ hội tiềm năng',
      color: 'from-[#2ecc71] to-[#00c897]'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Hỗ trợ ra quyết định',
      description: 'Cung cấp insights và khuyến nghị thông minh cho sale, marketing và quản lý',
      color: 'from-[#06b6d4] to-[#2a4b7c]'
    }
  ];

  return (
    <section ref={sectionRef} className="py-12 sm:py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-2 gap-8 sm:gap-12 md:gap-16 items-center">
          <div className={`order-2 md:order-1 transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
          }`}>
            <div className="relative">
              <img
                src={trolyaothongminh}
                alt="AI Assistant"
                className="w-full h-auto rounded-xl sm:rounded-2xl shadow-2xl"
              />
              <div className="absolute -top-3 -left-3 sm:-top-6 sm:-left-6 bg-white rounded-lg sm:rounded-xl shadow-xl p-3 sm:p-4 md:p-6 border border-gray-100">
                <div className="flex items-center space-x-2 sm:space-x-4">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-gradient-to-br from-[#06b6d4] to-[#00c897]">
                    <i className="ri-robot-line text-lg sm:text-xl md:text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">AI</div>
                    <div className="text-xs sm:text-sm text-gray-600">Trợ lý thông minh</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`order-1 md:order-2 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
          }`}>
            <div className="inline-flex items-center space-x-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-[#06b6d4]/10 text-[#06b6d4] text-xs sm:text-sm font-medium mb-3 sm:mb-4">
              <i className="ri-robot-2-line"></i>
              <span>TÍCH HỢP AI</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Trợ lý ảo thông minh trong CRM
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              AI được tích hợp trực tiếp vào hệ thống để tối ưu hóa mọi khía cạnh của quy trình bán hàng và chăm sóc khách hàng
            </p>

            <div className="space-y-4 sm:space-y-6">
              {aiFeatures.map((feature, index) => (
                <div key={index} className={`group p-4 sm:p-6 rounded-xl bg-gray-50 hover:bg-white hover:shadow-lg transition-all border border-transparent hover:border-[#06b6d4]/30 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`} style={{ transitionDelay: `${400 + index * 100}ms` }}>
                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-lg bg-gradient-to-br ${feature.color} flex-shrink-0 group-hover:scale-110 transition-transform`}>
                      <i className={`${feature.icon} text-lg sm:text-xl text-white`}></i>
                    </div>
                    <div>
                      <h4 className="text-base sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2">{feature.title}</h4>
                      <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 sm:mt-8 p-4 sm:p-6 rounded-xl bg-gradient-to-r from-[#06b6d4]/10 to-[#00c897]/10 border border-[#06b6d4]/20">
              <div className="flex items-start space-x-2 sm:space-x-3">
                <i className="ri-information-line text-[#06b6d4] text-lg sm:text-xl mt-0.5 flex-shrink-0"></i>
                <p className="text-xs sm:text-sm text-gray-700">
                  <strong className="text-[#2a4b7c]">AI học hỏi liên tục</strong> từ dữ liệu của doanh nghiệp bạn, 
                  ngày càng thông minh và chính xác hơn theo thời gian
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
